<template>
  <div>
    <v-card outlined>
      <v-card-title>Solicitudes por Status</v-card-title>
      <div ref="chart"></div>
    </v-card>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts';

export default {
  name: "SolicitudesStatusGraphic",
  props: {
    solicitudes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    solicitudes: {
      deep: true,
      handler() {
        if (this.chart && this.solicitudes.status) {
          const keys = Object.keys(this.solicitudes.status);
          const series = keys.map(k => this.solicitudes.status[k] || 0);
          // Actualizamos las series y etiquetas de la gráfica de forma dinámica
          this.chart.updateOptions({
            series: series,
            labels: keys
          });
        }
      }
    }
  },
  methods: {
    renderChart() {
      if (!this.solicitudes.status) return;
      const keys = Object.keys(this.solicitudes.status);
      const series = keys.map(k => this.solicitudes.status[k] || 0);

      const options = {
        series: series,
        chart: {
          height: 350,
          type: 'radialBar',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350
            }
          },
          // Evento para detectar clicks en los anillos
          events: {
            dataPointSelection: (event, chartContext, config) => {
              if (config.dataPointIndex !== undefined) {
                const selectedLabel = options.labels[config.dataPointIndex];
                this.$emit("searchUpdated", {
                  status: this.getPayload(selectedLabel)
                });
              }
            }
          }
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 350,
            hollow: {
              margin: 5,
              size: '30%',
              background: 'transparent'
            },
            track: {
              show: true,
              background: '#f2f2f2',
              opacity: 0.5,
              strokeWidth: '95%',
              margin: 5,
              dropShadow: {
                enabled: false
              }
            },
            dataLabels: {
              name: { show: false },
              value: { show: false },
              total: {
                show: true,
                label: 'Total',
                fontSize: '14px',
                formatter: function(w) {
                  return w.globals.seriesTotals.reduce((acc, val) => acc + val, 0);
                }
              }
            },
            // Bordes redondeados
            cornerRadius: '55%',
            strokeLinecap: 'round',
            trackSize: '95%',
            barSize: '85%',
            distributed: false
          }
        },
        stroke: {
          lineCap: 'round',
          width: 4
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: undefined,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        // Las etiquetas se generan a partir de las claves dinámicas
        labels: keys,
        legend: {
          show: true,
          floating: true,
          position: 'right',
          horizontalAlign: 'center',
          offsetY: 50,
          fontSize: '14px',
          labels: {
            useSeriesColors: true
          },
          markers: {
            size: 8,
            radius: 12
          },
          formatter: function(seriesName) {
            return seriesName;
          },
          itemMargin: {
            vertical: 10
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              show: true,
              position: 'bottom'
            }
          }
        }]
      };

      this.chart = new ApexCharts(this.$refs.chart, options);
      this.chart.render();
    },
    getPayload(selectedLabel) {
      const dictionary = {
        Nueva: 0,
        Asignada: 1,
        "En tramite": 2,
        "Pendiente de Aprobacion": 3,
        "Pendiente de Informacion": 4,
        Recotizar: 5,
        Cerrada: 6,
        Cancelada: 7,
      };
      return dictionary[selectedLabel];
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
:deep(.apexcharts-radialbar-track) path {
  stroke-linecap: round;
}

:deep(.apexcharts-radialbar) path {
  stroke-linecap: round;
}
</style>
